import React from "react"
import { Link } from "react-router-dom"
import classnames from "classnames"

import { NavbarBrand, Navbar, Container } from "reactstrap"

class OtherNavbar extends React.Component {
  render() {
    return (
      <>
        <Navbar
          className={classnames(
            "navbar-horizontal navbar-main navbar-dark py-4",
            { "bg-transparent": this.props.transparent },
            { "bg-chift": !this.props.transparent }
          )}
          expand="lg"
          id="navbar-main"
        >
          <Container>
            <NavbarBrand to="/" tag={Link}>
              <img
                alt="..."
                src={require("assets/img/brand/faver-white.png")}
              />
            </NavbarBrand>
            <hr className="d-lg-none" />
          </Container>
        </Navbar>
      </>
    )
  }
}

export default OtherNavbar
